import React, { useEffect } from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import { _delete } from "../../../Api";
import { toast } from "react-toastify";
import Button from "@material-ui/core/Button";
import DialogActions from "@material-ui/core/DialogActions";
import cloudStore from "../../../store/CloudStore";
import CircularProgress from "@material-ui/core/CircularProgress";
import { DialogContentText } from "@material-ui/core";

export default function RemoveAccountDialog(props) {
  const getDialogType = props.getType;
  const setDialogType = props.setType;
  const merchantId = props.merchant.id;
  const [merchant, setMerchant] = React.useState(null);
  const getSelectedAccount = props.getSelectedAccount;
  const setHandheldChange = props.setHandheldChange;
  const setOrderChange = props.setOrderChange;
  const setCloudChange = props.setCloudChange;

  function onChange() {
    const merchant = {
      id: cloudStore.merchant.id,
      inhouse: cloudStore.merchant.sp_merchants[0] ? !!cloudStore.merchant.sp_merchants[0].id : undefined,
      takeaway: cloudStore.merchant.ta_merchants[0] ? !!cloudStore.merchant.ta_merchants[0].id : undefined,
    };
    setMerchant(merchant);
  }

  useEffect(() => {
    cloudStore.addChangeListener(onChange);
    if (cloudStore.merchant != null) {
      onChange();
    }
    return () => cloudStore.removeChangeListener(onChange);
  }, []);

  function closeDialog() {
    setDialogType("null");
  }

  function removeHandheldUser() {
    const handheldUser = getSelectedAccount();
    _delete("/nova/merchant/" + merchantId + "/handheld/" + handheldUser.handheldUserId)
      .then(() => {
        toast.success("Handheld user removed successfully!", {
          position: "bottom-right",
          autoClose: 2000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        closeDialog();
        setHandheldChange(!props.handheldChange);
      })
      .catch((e) => {
        toast.error("Handheld user could not be removed.", {
          autoClose: 2000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        console.log(e);
        return Promise.reject();
      });
  }

  function removeHandheldAccount() {
    return (
      <Dialog open={!!getDialogType()} onClose={closeDialog}>
        <DialogTitle>Removing handheld account.</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Are you sure you want to remove handheld account{" "}
            {getSelectedAccount() ? getSelectedAccount().username : "unknown"}?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={closeDialog} color="primary">
            Cancel
          </Button>
          <Button onClick={removeHandheldUser} color="primary">
            Remove
          </Button>
        </DialogActions>
      </Dialog>
    );
  }

  function removeOrderUser() {
    const orderUser = getSelectedAccount();
    _delete("/nova/merchant/" + merchantId + "/mynbonnenuser/" + orderUser.orderUserId)
      .then(() => {
        toast.success("Order user removed successfully!", {
          position: "bottom-right",
          autoClose: 2000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        setOrderChange(!props.orderChange);
        closeDialog();
      })
      .catch((e) => {
        toast.error("Order user could not be removed.", {
          autoClose: 2000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        console.log(e);
        return Promise.reject();
      });
  }

  function removeOrderAccount() {
    return (
      <Dialog open={!!getDialogType()} onClose={closeDialog}>
        <DialogTitle>Removing handheld account.</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Are you sure you want to remove order account{" "}
            {getSelectedAccount() ? getSelectedAccount().email : "unknown"}?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={closeDialog} color="primary">
            Cancel
          </Button>
          <Button onClick={removeOrderUser} color="primary">
            Remove
          </Button>
        </DialogActions>
      </Dialog>
    );
  }

  function removeCloudUser() {
    const cloudUser = getSelectedAccount();
    _delete("/nova/merchant/" + merchantId + "/cloudaccount/" + cloudUser.cloudUserId)
      .then(() => {
        toast.success("Cloud user removed successfully!", {
          position: "bottom-right",
          autoClose: 2000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        closeDialog();
        setCloudChange(!props.cloudChange);
      })
      .catch((e) => {
        toast.error("Cloud user could not be removed.", {
          autoClose: 2000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        console.log(e);
        return Promise.reject();
      });
  }

  function removeCloudAccount() {
    return (
      <Dialog open={!!getDialogType()} onClose={closeDialog}>
        <DialogTitle>Removing cloud account.</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Are you sure you want to remove order account{" "}
            {getSelectedAccount() ? getSelectedAccount().username : "unknown"}?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={closeDialog} color="primary">
            Cancel
          </Button>
          <Button onClick={removeCloudUser} color="primary">
            Remove
          </Button>
        </DialogActions>
      </Dialog>
    );
  }

  if (!merchant) {
    return (
      <div align="center">
        <CircularProgress color="primary" />
      </div>
    );
  }

  switch (getDialogType()) {
    case "handheld":
      return removeHandheldAccount();
    case "order":
      return removeOrderAccount();
    case "cloud":
      return removeCloudAccount();

    default:
      return <div />;
  }
}
